import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { useEntityCrud } from '../../hooks/useEntityCrud';
 

const UploadLogo = () => {

     const [file, setFile] = useState('');

    const { addData } = useEntityCrud("Info/updateHoldingInfo")
    const { readDataGet } = useEntityCrud('Info/GetHoldingInfo');


    useEffect(() => {
        getData();
    }, []);

    const setFileBase64 = async e => {
        document.getElementById('file-input-label').innerText = e.target.files[0].name;
        const fileData = await toBase64(e.target.files[0]);
        setFile(fileData);
    }

    const toBase64 = async file => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = error => reject(error);
        });
    }

    const getData = () => {
         
        readDataGet().then(({ data }) => {
             
            if (data.status) {
                setFile(`data:image/png;base64,${data.result.logo}`)
            }
        });
    }


    function handleSubmit(e) {
        e.preventDefault();
        const body = {
            "logo": file,
            "title": "",
            "address": "",
            "phone": "",
            "id": 0
        }
        addData(body)
            .then(({ data }) => {
                if (data.status) {
                    toast.success('عملیات مورد نظر با موفقیت انجام شد');
                } else
                    toast.error(data.message);
            })
    }

    console.log(file);

    return (

        <div className=" baseInfo_">
            <form onSubmit={handleSubmit}>
                <div className='row mx-auto' style={{ display: "flex", alignItems: "end" }}>

                    <label>آپلود لوگو</label>

                    <div className="col-md-3">

                        <div className="form-group">

                            <div className="custom-file">
                                <input className="custom-file-input" onChange={setFileBase64} id="customFile"
                                    type="file" accept="image/jpeg" /><label className="custom-file-label" id="file-input-label"
                                        htmlFor="customFile">انتخاب لوگو</label>
                            </div>

                            {file && !file.includes('null') && <img src={file} style={{ margin: " 2% 0" }} />}

                        </div>
                    </div>
                    <div className="col-md-12">
                        <div className="form-group mb-0">
                            <button className="btn btn-success px-4 btn-block">ذخیره اطلاعات</button>
                        </div>
                    </div>
                </div>
                ّ
            </form>
        </div>
    );
};


export default UploadLogo;
